<template>
  <div
    class="basic_vip_footer"
    v-if="$store.state.vip.switch && $store.state.app.view_pattern === 'pc'"
  >
    <div class="vip_logo_footer">
      <div class="big_vip_part">
        <div class="testtest">zxtVisible: {{ zxtVisible }}</div>
        <div class="base_big_vip_part main_big_vip_part" v-show="zxtVisible">
          <div class="big_vip_icon">
            <img src="https://staticjs.71360.com/3/static/image/big_vip_icon.png"/>
          </div>
          <div class="words_content">
            <p class="base_word">{{$t('widgets_basic_copyright_index_486')}}</p>
          </div>
          <div class="words_content day_part" id="rotatey1">
            <p class="day_number">
              {{ $store.state.vip.day }}
              <span>{{$t('widgets_basic_copyright_index_487')}}</span>
            </p>
            <p class="show_tag">{{$t('widgets_basic_copyright_index_488')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_vip_footer',
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  computed: {
    zxtVisible() {
      return Number(this.$store.state.app.road_type) !== 1
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_vip_footer {
  .vip_logo_footer {
    .big_vip_part {
      margin: 10px auto;
      width: 134px;
      height: 50px;

      &.inline {
        display: inline-block;
        margin: 0;
        margin-left: 10px;
        vertical-align: middle;
      }

      .base_big_vip_part {
        width: 134px;
        height: 50px;
        background: url(https://staticjs.71360.com/3/static/image/big_vip_bg.png) no-repeat;
        overflow: hidden;
        background-size: 100% 100%;
        font-size: 0;
        text-align: left;

        .big_vip_icon {
          display: inline-block;
          vertical-align: middle;
          height: 38px;
          margin: 6px 8px;
          width: 40px;

          img {
            max-height: 100%;
            max-width: 100%;
          }
        }

        .words_content {
          height: 38px;
          display: inline-block;
          vertical-align: middle;
          color: #fff !important;
          width: 50%;
          text-align: center;

          .base_word {
            font-size: 16px;
            font-weight: bold;
            font-family: 'SourceHanSansCN Bold';
            line-height: 38px;
            color: #fff;
          }

          .day_number {
            font-size: 14px;
            font-weight: bold;
            font-family: 'Franklin Gothic Demi Cond';
            line-height: 20px;
            color: #fff;

            span {
              font-size: 12px;
              font-weight: bold;
              font-family: 'SourceHanSansCN Regular';
              color: #fff;
            }
          }

          .show_tag {
            font-size: 12px;
            font-family: 'SourceHanSansCN Regular';
            position: relative;
            text-align: center;
            line-height: 12px;
            color: #fff;

            &::after,
            &::before {
              display: block;
              content: '';
              width: 10px;
              height: 1px;
              background-color: #fff;
              position: absolute;
              top: 6px;
            }

            &::after {
              right: -1px;
            }

            &::before {
              left: 1px;
            }
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/widgets/basic_vip_footer/index.vue